import React, { useState, useEffect, useRef } from "react";
import styled, { keyframes, css } from "styled-components";
// Dark 테마용 아이콘들
import s10Icon from "../../../../assets/images/weather_icon/S10.png";
import s11Icon from "../../../../assets/images/weather_icon/S11.png";
import s12Icon from "../../../../assets/images/weather_icon/S12.png";
import s13Icon from "../../../../assets/images/weather_icon/S13.png";
import s14Icon from "../../../../assets/images/weather_icon/S14.png";
import s15Icon from "../../../../assets/images/weather_icon/S15.png";
import s16Icon from "../../../../assets/images/weather_icon/S16.png";
import s17Icon from "../../../../assets/images/weather_icon/S17.png";
import s30Icon from "../../../../assets/images/weather_icon/S30.png";
import s31Icon from "../../../../assets/images/weather_icon/S31.png";
import s32Icon from "../../../../assets/images/weather_icon/S32.png";
import s33Icon from "../../../../assets/images/weather_icon/S33.png";
import s34Icon from "../../../../assets/images/weather_icon/S34.png";
import s35Icon from "../../../../assets/images/weather_icon/S35.png";
import s36Icon from "../../../../assets/images/weather_icon/S36.png";
import s37Icon from "../../../../assets/images/weather_icon/S37.png";
import s40Icon from "../../../../assets/images/weather_icon/S40.png";
import s41Icon from "../../../../assets/images/weather_icon/S41.png";
import s42Icon from "../../../../assets/images/weather_icon/S42.png";
import s43Icon from "../../../../assets/images/weather_icon/S43.png";
import s44Icon from "../../../../assets/images/weather_icon/S44.png";
import s45Icon from "../../../../assets/images/weather_icon/S45.png";
import s46Icon from "../../../../assets/images/weather_icon/S46.png";
import s47Icon from "../../../../assets/images/weather_icon/S47.png";

// Light 테마용 아이콘들 (_black 버전)
import s10BlackIcon from "../../../../assets/images/weather_icon/S10_black.png";
import s11BlackIcon from "../../../../assets/images/weather_icon/S11_black.png";
import s12BlackIcon from "../../../../assets/images/weather_icon/S12_black.png";
import s13BlackIcon from "../../../../assets/images/weather_icon/S13_black.png";
import s14BlackIcon from "../../../../assets/images/weather_icon/S14_black.png";
import s15BlackIcon from "../../../../assets/images/weather_icon/S15_black.png";
import s16BlackIcon from "../../../../assets/images/weather_icon/S16_black.png";
import s17BlackIcon from "../../../../assets/images/weather_icon/S17_black.png";
import s30BlackIcon from "../../../../assets/images/weather_icon/S30_black.png";
import s31BlackIcon from "../../../../assets/images/weather_icon/S31_black.png";
import s32BlackIcon from "../../../../assets/images/weather_icon/S32_black.png";
import s33BlackIcon from "../../../../assets/images/weather_icon/S33_black.png";
import s34BlackIcon from "../../../../assets/images/weather_icon/S34_black.png";
import s35BlackIcon from "../../../../assets/images/weather_icon/S35_black.png";
import s36BlackIcon from "../../../../assets/images/weather_icon/S36_black.png";
import s37BlackIcon from "../../../../assets/images/weather_icon/S37_black.png";
import s40BlackIcon from "../../../../assets/images/weather_icon/S40_black.png";
import s41BlackIcon from "../../../../assets/images/weather_icon/S41_black.png";
import s42BlackIcon from "../../../../assets/images/weather_icon/S42_black.png";
import s43BlackIcon from "../../../../assets/images/weather_icon/S43_black.png";
import s44BlackIcon from "../../../../assets/images/weather_icon/S44_black.png";
import s45BlackIcon from "../../../../assets/images/weather_icon/S45_black.png";
import s46BlackIcon from "../../../../assets/images/weather_icon/S46_black.png";
import s47BlackIcon from "../../../../assets/images/weather_icon/S47_black.png";
import humidityIcon from "../../../../assets/images/weather_icon/humidity.png";
import windspeedIcon from "../../../../assets/images/weather_icon/windspeed.png";
import precipitationIcon from "../../../../assets/images/weather_icon/precipitation.png";
import {
  getWeatherData,
  getWeatherForecastData,
  viewCheckActivateStateApiRequest,
  viewCheckUpdateStateApiRequest,
} from "../../../../utils/indexedDB";
import { useAtom } from "jotai";
import {
  AUTODISPLAY_INTERVER_TIME,
  AUTODISPLAY_REACT_STATE,
  AUTODISPLAY_DISPLAY_WIDTH,
  AUTODISPLAY_DISPLAY_HEIGHT,
} from "../../../AtomStates";

const marqueeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 4em));
  }
`;

// Dark 테마용 날씨 아이콘 매핑 객체
const darkWeatherIcons = {
  S10: s10Icon,
  S11: s11Icon,
  S12: s12Icon,
  S13: s13Icon,
  S14: s14Icon,
  S15: s15Icon,
  S16: s16Icon,
  S17: s17Icon,
  S30: s30Icon,
  S31: s31Icon,
  S32: s32Icon,
  S33: s33Icon,
  S34: s34Icon,
  S35: s35Icon,
  S36: s36Icon,
  S37: s37Icon,
  S40: s40Icon,
  S41: s41Icon,
  S42: s42Icon,
  S43: s43Icon,
  S44: s44Icon,
  S45: s45Icon,
  S46: s46Icon,
  S47: s47Icon,
};

// Light 테마용 날씨 아이콘 매핑 객체
const lightWeatherIcons = {
  S10: s10BlackIcon,
  S11: s11BlackIcon,
  S12: s12BlackIcon,
  S13: s13BlackIcon,
  S14: s14BlackIcon,
  S15: s15BlackIcon,
  S16: s16BlackIcon,
  S17: s17BlackIcon,
  S30: s30BlackIcon,
  S31: s31BlackIcon,
  S32: s32BlackIcon,
  S33: s33BlackIcon,
  S34: s34BlackIcon,
  S35: s35BlackIcon,
  S36: s36BlackIcon,
  S37: s37BlackIcon,
  S40: s40BlackIcon,
  S41: s41BlackIcon,
  S42: s42BlackIcon,
  S43: s43BlackIcon,
  S44: s44BlackIcon,
  S45: s45BlackIcon,
  S46: s46BlackIcon,
  S47: s47BlackIcon,
};

// 테마에 따른 아이콘 코드로 실제 아이콘 이미지 가져오기
const getWeatherIconImage = (iconCode, themeMode = "dark") => {
  const iconMap = themeMode === "light" ? lightWeatherIcons : darkWeatherIcons;
  const defaultIcon = themeMode === "light" ? s30BlackIcon : s30Icon;
  return iconMap[iconCode] || defaultIcon;
};

// 테마별 컬러 매핑 객체
const apiThemeColors = {
  dark: {
    textColor: "white",
    mainBackgroundColor: "#272727",
    weatherCardBackground: "rgba(255, 255, 255, 0.1)",
    dividerColor: "white",
    bottomBorderColor: "rgba(255, 255, 255, 0.4)",
  },
  light: {
    textColor: "black",
    mainBackgroundColor: "#FDFDFD",
    weatherCardBackground: "rgba(0, 0, 0, 0.05)",
    dividerColor: "black",
    bottomBorderColor: "rgba(0, 0, 0, 0.4)",
  },
};

/**
 * 테마모드에 따른 색상을 가져오는 함수
 * @param {string} colorName - 색상 이름
 * @param {string} themeMode - 테마 모드 ("dark" 또는 "light")
 * @returns {string} 해당 테마의 색상 값
 */
const getApiThemeColor = (colorName, themeMode = "dark") => {
  const theme = apiThemeColors[themeMode] || apiThemeColors.dark;
  return theme[colorName] || apiThemeColors.dark[colorName];
};

const OrganismDisplayViewApiFixed = ({
  path,
  activateCode,
  activateTimestamp,
  textData: initialTextData,
  locationData: initialLocationData,
  themeMode: initialThemeMode, // "dark" or "light"
}) => {
  // 기존 props를 useState로 관리
  const [textData, setTextData] = useState(initialTextData);
  const [locationData, setLocationData] = useState(initialLocationData);
  const [themeMode, setThemeMode] = useState(initialThemeMode || "dark");

  const [isTextOverflowing, setIsTextOverflowing] = useState(false);
  const messageContainerRef = useRef(null);
  const messageTextRef = useRef(null);

  // 고정 크기 설정 (192px x 448px)
  const FIXED_WIDTH = 192;
  const FIXED_HEIGHT = 448;
  const [currentDate, setCurrentDate] = useState(new Date());
  const [weatherData, setWeatherData] = useState({
    temperature: "25",
    wind: "2.3",
    precipitation: "2",
    humidity: "72",
    pty: "0", // 강수형태 추가
  });
  const lastWeatherUpdateHourRef = useRef(null);

  const [currentTime, setCurrentTime] = useState(new Date());
  const [weatherForecastData, setWeatherForecastData] = useState({
    maxTemperature: "34",
    minTemperature: "23",
    sky: "1", // 1: 맑음, 3: 구름많음, 4: 흐림
  });
  const [lastTempUpdateDate, setLastTempUpdateDate] = useState(null); // TMX, TMN 마지막 업데이트 날짜

  const [autodisplayIntervalTime] = useAtom(AUTODISPLAY_INTERVER_TIME);

  useEffect(() => {
    // 테스트 모드일 때는 API 호출 건너뛰기
    if (path === "test-path") {
      // console.log("테스트 모드: API 호출 건너뛰기");
      return;
    }

    const checkActivateState = async () => {
      try {
        const response = await viewCheckActivateStateApiRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
          activateCheckTimestamp: Date.now(),
        });

        if (response && response.status === "nonActivate") {
          window.location.href = "/AutodisplayViewApi";
        }
      } catch (error) {
        console.error(error);
        window.location.href = "/AutodisplayViewApi";
      }
    };

    const checkUpdateState = async () => {
      try {
        const response = await viewCheckUpdateStateApiRequest({
          viewId: path,
          activateCode,
          activateTimestamp: activateTimestamp,
        });
        console.log("checkUpdateState", response);

        // 응답이 success인 경우 데이터 업데이트
        if (response && response.status === "success") {
          if (response.textData) {
            setTextData(response.textData);
          }

          if (response.contentData) {
            const locationData = {
              selectedRegion: response.contentData.selectedRegion,
              selectedDistricts: response.contentData.selectedDistricts,
            };
            setLocationData(locationData);
          }

          if (response.designConcept) {
            const themeModeValue = response.designConcept[0];
            const designConcept =
              themeModeValue === "다크 모드" ? "dark" : "light";
            console.log(
              "🎨 API에서 받은 테마:",
              themeModeValue,
              "→ 변환된 테마:",
              designConcept
            );
            setThemeMode(designConcept);
          }
        }
      } catch (error) {
        console.error(error);
      }
    };

    // 초기 실행
    checkActivateState();
    checkUpdateState();

    // 10분마다 반복 실행
    const interval = setInterval(() => {
      checkActivateState();
      checkUpdateState();
    }, autodisplayIntervalTime);

    // 컴포넌트 언마운트 시 인터벌 정리
    return () => clearInterval(interval);
  }, [path, activateCode, activateTimestamp, autodisplayIntervalTime]);

  useEffect(() => {
    const checkOverflow = () => {
      const container = messageContainerRef.current;
      const text = messageTextRef.current;
      if (container && text) {
        const isOverflow = text.scrollWidth > container.clientWidth;
        if (isOverflow !== isTextOverflowing) {
          setIsTextOverflowing(isOverflow);
        }
      }
    };

    const timer = setTimeout(checkOverflow, 100);
    window.addEventListener("resize", checkOverflow);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [textData, isTextOverflowing]);

  const fetchWeatherData = async () => {
    // 테스트 모드일 때는 API 호출 건너뛰기
    // if (path === "test-path") {
    //   console.log("테스트 모드: 날씨 API 호출 건너뛰기");
    //   return;
    // }

    const now = new Date();
    let base_date_obj = new Date();

    let currentHour = now.getHours();
    let base_time = "";

    // 초단기실황 API는 매시 45분 이후에 데이터가 제공됩니다.
    // 안전하게 45분 미만일 경우 이전 시간의 데이터를 요청합니다.
    if (now.getMinutes() < 45) {
      // 현재 시간이 0시이고 45분 미만이면, 전날 23시 데이터를 요청합니다.
      if (currentHour === 0) {
        base_date_obj.setDate(base_date_obj.getDate() - 1);
        base_time = "2300";
      } else {
        // 0시가 아니면, 현재 시간 -1 시간으로 요청합니다.
        base_time = `${String(currentHour - 1).padStart(2, "0")}00`;
      }
    } else {
      // 45분 이상이면 현재 시간으로 데이터를 요청합니다.
      base_time = `${String(currentHour).padStart(2, "0")}00`;
    }

    const base_date = `${base_date_obj.getFullYear()}${String(
      base_date_obj.getMonth() + 1
    ).padStart(2, "0")}${String(base_date_obj.getDate()).padStart(2, "0")}`;

    const nx = locationData.selectedDistricts.x;
    const ny = locationData.selectedDistricts.y;

    const params = {
      pageNo: 1,
      numOfRows: 10,
      dataType: "JSON",
      base_date: base_date,
      base_time: base_time,
      nx,
      ny,
    };

    try {
      const response = await getWeatherData(params);
      console.log("기상정보 response", response);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const weather = {};
        items.forEach((item) => {
          switch (item.category) {
            case "T1H": // 기온
              weather.temperature = item.obsrValue;
              break;
            case "RN1": // 1시간 강수량
              weather.precipitation = item.obsrValue;
              break;
            case "WSD": // 풍속
              weather.wind = item.obsrValue;
              break;
            case "REH": // 습도
              weather.humidity = item.obsrValue;
              break;
            case "PTY": // 강수형태
              weather.pty = item.obsrValue;
              break;
            default:
              break;
          }
        });
        console.log("weather", weather);
        setWeatherData((prevData) => ({ ...prevData, ...weather }));
      } else {
        console.error(
          "Weather API Error:",
          response.data.response.header.resultMsg
        );
      }
    } catch (error) {
      console.error("Failed to fetch weather data:", error);
    }
  };

  // 날씨 예보 API 파라미터 계산 함수
  const calculateForecastParams = (currentTime) => {
    const year = currentTime.getFullYear();
    const month = String(currentTime.getMonth() + 1).padStart(2, "0");
    const day = String(currentTime.getDate()).padStart(2, "0");
    const hour = currentTime.getHours();

    // API 발표 시간 기준
    let baseTime;
    if (hour >= 23) {
      baseTime = "2300";
    } else if (hour >= 20) {
      baseTime = "2000";
    } else if (hour >= 17) {
      baseTime = "1700";
    } else if (hour >= 14) {
      baseTime = "1400";
    } else if (hour >= 11) {
      baseTime = "1100";
    } else if (hour >= 8) {
      baseTime = "0800";
    } else if (hour >= 5) {
      baseTime = "0500";
    } else {
      baseTime = "0200";
    }

    // 새벽 시간대는 전날 데이터 사용
    let baseDate;
    if (hour < 2) {
      const yesterday = new Date(currentTime);
      yesterday.setDate(yesterday.getDate() - 1);
      baseDate = `${yesterday.getFullYear()}${String(
        yesterday.getMonth() + 1
      ).padStart(2, "0")}${String(yesterday.getDate()).padStart(2, "0")}`;
      baseTime = "2300";
    } else {
      baseDate = `${year}${month}${day}`;
    }

    return {
      pageNo: 1,
      base_date: baseDate,
      base_time: baseTime,
    };
  };

  // 폰트 로드 함수
  const loadFonts = () => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Pretendard:wght@400;500;600;700&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  };

  // 날씨 예보 데이터 가져오기
  const fetchWeatherForecast = async () => {
    // 테스트 모드일 때는 API 호출 건너뛰기
    // if (path === "test-path") {
    //   console.log("테스트 모드: 날씨 예보 API 호출 건너뛰기");
    //   return;
    // }

    try {
      const now = new Date();
      const params = calculateForecastParams(now);

      const forecastParams = {
        pageNo: params.pageNo,
        numOfRows: 12,
        dataType: "JSON",
        base_date: params.base_date,
        base_time: params.base_time,
        nx: locationData.selectedDistricts.x, // 지역별 X 좌표
        ny: locationData.selectedDistricts.y, // 지역별 Y 좌표
      };

      const response = await getWeatherForecastData(forecastParams);
      console.log(`예보 데이터 (${now.getHours()}시):`, params, response);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const forecast = {};

        items.forEach((item) => {
          switch (item.category) {
            case "SKY": // 하늘 상태
              forecast.sky = item.fcstValue;
              break;
            // TMX, TMN은 별도 함수에서 처리하므로 제거
          }
        });

        setWeatherForecastData((prev) => ({ ...prev, ...forecast }));
      }

      // 임시 데이터 (개발용)
      console.log(`예보 API 파라미터 (${now.getHours()}시):`, params);
    } catch (error) {
      console.error("날씨 예보 데이터 가져오기 실패:", error);
    }
  };

  // TMX, TMN 데이터 가져오기 (매일 02시 기준)
  const fetchTemperatureMinMax = async () => {
    // 테스트 모드일 때는 API 호출 건너뛰기
    // if (path === "test-path") {
    //   console.log("테스트 모드: TMX, TMN API 호출 건너뛰기");
    //   return;
    // }

    try {
      const now = new Date();
      const currentDate = `${now.getFullYear()}${String(
        now.getMonth() + 1
      ).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}`;

      // 이미 오늘 업데이트했다면 스킵
      if (lastTempUpdateDate === currentDate) {
        console.log("TMX, TMN 데이터는 이미 오늘 업데이트됨");
        return;
      }

      const tempParams = {
        pageNo: 1,
        numOfRows: 300,
        dataType: "JSON",
        base_date: currentDate,
        base_time: "0200",
        nx: locationData.selectedDistricts.x,
        ny: locationData.selectedDistricts.y,
      };

      console.log("TMX, TMN 데이터 요청:", tempParams);
      const response = await getWeatherForecastData(tempParams);

      if (response.data.response.header.resultCode === "00") {
        const items = response.data.response.body.items.item;
        const tempData = {};

        // 오늘 날짜의 TMX, TMN 찾기
        items.forEach((item) => {
          if (item.fcstDate === currentDate) {
            switch (item.category) {
              case "TMX": // 최고 기온
                tempData.maxTemperature = item.fcstValue;
                console.log("최고 기온:", item.fcstValue);
                break;
              case "TMN": // 최저 기온
                tempData.minTemperature = item.fcstValue;
                console.log("최저 기온:", item.fcstValue);
                break;
            }
          }
        });

        // 데이터가 있으면 업데이트
        if (tempData.maxTemperature || tempData.minTemperature) {
          setWeatherForecastData((prev) => ({ ...prev, ...tempData }));
          setLastTempUpdateDate(currentDate);
          console.log("TMX, TMN 데이터 업데이트 완료:", tempData);
        } else {
          console.log("오늘 날짜의 TMX, TMN 데이터를 찾을 수 없음");
        }
      }
    } catch (error) {
      console.error("TMX, TMN 데이터 가져오기 실패:", error);
    }
  };

  // 현재 온도와 최대/최저 온도 비교하여 업데이트
  useEffect(() => {
    if (
      weatherData.temperature &&
      (weatherForecastData.maxTemperature || weatherForecastData.minTemperature)
    ) {
      const currentTemp = parseFloat(weatherData.temperature);
      let shouldUpdate = false;
      let updateData = {};

      // 최대 온도 체크
      if (weatherForecastData.maxTemperature) {
        const maxTemp = parseFloat(weatherForecastData.maxTemperature);
        if (currentTemp > maxTemp) {
          console.log(
            `현재 온도(${currentTemp}°C)가 최대 온도(${maxTemp}°C)보다 높아서 최대 온도를 업데이트합니다.`
          );
          updateData.maxTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      // 최저 온도 체크
      if (weatherForecastData.minTemperature) {
        const minTemp = parseFloat(weatherForecastData.minTemperature);
        if (currentTemp < minTemp) {
          console.log(
            `현재 온도(${currentTemp}°C)가 최저 온도(${minTemp}°C)보다 낮아서 최저 온도를 업데이트합니다.`
          );
          updateData.minTemperature = weatherData.temperature;
          shouldUpdate = true;
        }
      }

      if (shouldUpdate) {
        setWeatherForecastData((prev) => ({
          ...prev,
          ...updateData,
        }));
      }
    }
  }, [
    weatherData.temperature,
    weatherForecastData.maxTemperature,
    weatherForecastData.minTemperature,
  ]);

  useEffect(() => {
    fetchWeatherData();

    const weatherTimerId = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();

      // 매시간 15분에 업데이트
      if (now.getMinutes() === 15) {
        if (lastWeatherUpdateHourRef.current !== currentHour) {
          fetchWeatherData();
          lastWeatherUpdateHourRef.current = currentHour;
        }
      }
    }, 60000); // 1분마다 체크

    const dateTimerId = setInterval(() => {
      setCurrentDate(new Date());
    }, 60000);

    return () => {
      clearInterval(weatherTimerId);
      clearInterval(dateTimerId);
    };
  }, []);

  // 폰트 로드 및 날씨 데이터 가져오기 useEffect
  useEffect(() => {
    // 폰트 로드
    loadFonts();

    // 초기 데이터 가져오기
    fetchWeatherData(); // 실황 날씨 데이터
    fetchWeatherForecast();
    fetchTemperatureMinMax(); // TMX, TMN 초기 로드

    // 매시간 정각에 예보 데이터 업데이트
    const weatherInterval = setInterval(() => {
      const now = new Date();
      const currentHour = now.getHours();

      if (now.getMinutes() === 0) {
        fetchWeatherData(); // 매시간 실황 데이터 업데이트
        fetchWeatherForecast();

        // 매일 02시에 TMX, TMN 업데이트
        if (currentHour === 2) {
          fetchTemperatureMinMax();
        }
      }
    }, 60000); // 1분마다 체크

    return () => {
      clearInterval(weatherInterval);
    };
  }, [path, locationData]); // path와 locationData가 변경되면 다시 실행

  // 반응형 로직 제거 - 고정 크기만 사용

  // 시간 업데이트
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000); // 60초(1분)마다 업데이트

    // 컴포넌트 마운트 시 즉시 한 번 실행
    setCurrentTime(new Date());

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date) => {
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const dayOfWeek = ["일", "월", "화", "수", "목", "금", "토"][date.getDay()];
    return `${year}.${month}.${day} (${dayOfWeek})`;
  };

  // 하늘 상태에 따른 날씨 텍스트
  const getWeatherStatus = (skyCode) => {
    switch (skyCode) {
      case "1":
        return "맑음";
      case "3":
        return "구름 많음";
      case "4":
        return "흐림";
      default:
        return "구름 많음";
    }
  };

  // SKY와 PTY 값을 조합하여 날씨 아이콘 코드 생성
  const getWeatherIconCode = (skyCode, ptyCode) => {
    // 아이콘 파일명: S + SKY값 + PTY값
    // 예: 맑음(SKY=1) + 없음(PTY=0) = S10
    // 예: 흐림(SKY=4) + 비/눈(PTY=2) = S42
    return `S${skyCode}${ptyCode}`;
  };

  // 현재 날씨 아이콘 코드 계산
  const currentWeatherIcon = getWeatherIconCode(
    weatherForecastData.sky,
    weatherData.pty
  );

  // 체감온도 계산 함수
  const calculateFeelsLike = (temperature, humidity, windSpeed) => {
    const temp = parseFloat(temperature);
    const humid = parseFloat(humidity);
    const wind = parseFloat(windSpeed);

    // 온도가 26.7°C 이상일 때: Heat Index (열 지수) 사용
    if (temp >= 26.7) {
      // 섭씨를 화씨로 변환
      const tempF = (temp * 9) / 5 + 32;

      // Heat Index 계산 (화씨 기준)
      const c1 = -42.379;
      const c2 = 2.04901523;
      const c3 = 10.14333127;
      const c4 = -0.22475541;
      const c5 = -0.00683783;
      const c6 = -0.05481717;
      const c7 = 0.00122874;
      const c8 = 0.00085282;
      const c9 = -0.00000199;

      const heatIndexF =
        c1 +
        c2 * tempF +
        c3 * humid +
        c4 * tempF * humid +
        c5 * tempF * tempF +
        c6 * humid * humid +
        c7 * tempF * tempF * humid +
        c8 * tempF * humid * humid +
        c9 * tempF * tempF * humid * humid;

      // 화씨를 섭씨로 변환
      const heatIndexC = ((heatIndexF - 32) * 5) / 9;
      return Math.round(heatIndexC);
    }

    // 온도가 10°C 이하일 때: Wind Chill (바람차가움 지수) 사용
    else if (temp <= 10) {
      // 풍속을 m/s에서 km/h로 변환
      const windKmh = wind * 3.6;

      // Wind Chill 계산 (풍속이 4.8km/h 이상일 때만 적용)
      if (windKmh >= 4.8) {
        const windChill =
          13.12 +
          0.6215 * temp -
          11.37 * Math.pow(windKmh, 0.16) +
          0.3965 * temp * Math.pow(windKmh, 0.16);
        return Math.round(windChill);
      } else {
        // 바람이 약할 때는 실제 온도 반환
        return Math.round(temp);
      }
    }

    // 중간 온도대 (10°C ~ 26.7°C): 습도 기반 보정
    else {
      let adjustment = 0;

      // 습도가 높을 때 (70% 이상) 더 덥게 느껴짐
      if (humid >= 70) {
        adjustment = (humid - 70) * 0.1; // 습도 10%당 1도씩 증가
      }
      // 습도가 낮을 때 (30% 이하) 더 시원하게 느껴짐
      else if (humid <= 30) {
        adjustment = (30 - humid) * -0.05; // 습도 10%당 0.5도씩 감소
      }

      // 바람 효과 (풍속 1m/s당 약 0.5도 시원하게)
      const windAdjustment = wind * -0.5;

      const feelsLike = temp + adjustment + windAdjustment;
      return Math.round(feelsLike);
    }
  };

  // 체감온도 계산
  const feelsLikeTemperature = calculateFeelsLike(
    weatherData.temperature,
    weatherData.humidity,
    weatherData.wind
  );

  const textContent =
    textData || "실시간 날씨 정보를 확인하세요 · 정확한 기상 데이터 제공";

  return (
    <StyledMainContainer themeMode={themeMode}>
      <StyledContentWrapper>
        <StyledMainContentArea>
          {/* 섹션 1: 타이틀 섹션 */}
          <StyledTitleSection>
            <StyledLocationTitle themeMode={themeMode}>
              {locationData?.selectedRegion || "서울특별시 강남구"}
            </StyledLocationTitle>
            <StyledDateTimeSection>
              <StyledTimeText themeMode={themeMode}>
                {formatTime(currentTime)}
              </StyledTimeText>
              <StyledDateText themeMode={themeMode}>
                {formatDate(currentTime)}
              </StyledDateText>
            </StyledDateTimeSection>
          </StyledTitleSection>

          {/* 섹션 2: 날씨 메인 섹션 */}
          <StyledWeatherMainSection>
            <StyledWeatherIconSection>
              <StyledWeatherIcon
                src={getWeatherIconImage(currentWeatherIcon, themeMode)}
                alt={getWeatherStatus(weatherForecastData.sky)}
              />
              <StyledTemperatureSection>
                <StyledTemperatureText themeMode={themeMode}>
                  {weatherData.temperature}°
                </StyledTemperatureText>
                <StyledWeatherStatusText themeMode={themeMode}>
                  {getWeatherStatus(weatherForecastData.sky)}
                </StyledWeatherStatusText>
              </StyledTemperatureSection>
            </StyledWeatherIconSection>

            <StyledTempInfoSection>
              <StyledMinMaxSection>
                <StyledMinMaxTempText themeMode={themeMode}>
                  최저 {weatherForecastData.minTemperature}°
                </StyledMinMaxTempText>
                <StyledDivider themeMode={themeMode} />
                <StyledMinMaxTempText themeMode={themeMode}>
                  최고 {weatherForecastData.maxTemperature}°
                </StyledMinMaxTempText>
              </StyledMinMaxSection>
              <StyledFeelsLikeText themeMode={themeMode}>
                체감 온도 {feelsLikeTemperature}°
              </StyledFeelsLikeText>
            </StyledTempInfoSection>
          </StyledWeatherMainSection>

          {/* 섹션 3: 날씨 상세 섹션 */}
          <StyledWeatherDetailsSection>
            <StyledWeatherDetailCard themeMode={themeMode}>
              <StyledDetailIconSection>
                <StyledHumidityIcon />
                <StyledWeatherLabelText themeMode={themeMode}>
                  습도
                </StyledWeatherLabelText>
              </StyledDetailIconSection>
              <StyledDetailValueSection>
                <StyledWeatherValueText themeMode={themeMode}>
                  {weatherData.humidity}
                </StyledWeatherValueText>
                <StyledWeatherUnitText themeMode={themeMode}>
                  %
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>

            <StyledWeatherDetailCard themeMode={themeMode}>
              <StyledDetailIconSection>
                <StyledWindSpeedIcon />
                <StyledWeatherLabelText themeMode={themeMode}>
                  풍속
                </StyledWeatherLabelText>
              </StyledDetailIconSection>
              <StyledDetailValueSection>
                <StyledWeatherValueText themeMode={themeMode}>
                  {weatherData.wind}
                </StyledWeatherValueText>
                <StyledWeatherUnitText themeMode={themeMode}>
                  m/s
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>

            <StyledWeatherDetailCard themeMode={themeMode}>
              <StyledDetailIconSection>
                <StyledRainIcon />
                <StyledWeatherLabelText themeMode={themeMode}>
                  강수량
                </StyledWeatherLabelText>
              </StyledDetailIconSection>

              <StyledDetailValueSection>
                <StyledWeatherValueText themeMode={themeMode}>
                  {weatherData.precipitation === "0"
                    ? "0"
                    : weatherData.precipitation}
                </StyledWeatherValueText>
                <StyledWeatherUnitText themeMode={themeMode}>
                  mm/h
                </StyledWeatherUnitText>
              </StyledDetailValueSection>
            </StyledWeatherDetailCard>
          </StyledWeatherDetailsSection>
        </StyledMainContentArea>

        {/* 섹션 4: 하단 메시지 섹션 */}
        <StyledBottomMessage ref={messageContainerRef} themeMode={themeMode}>
          <StyledMessageText
            ref={messageTextRef}
            isOverflowing={isTextOverflowing}
            data-text={textContent}
            themeMode={themeMode}
          >
            {textContent}
          </StyledMessageText>
        </StyledBottomMessage>
      </StyledContentWrapper>
    </StyledMainContainer>
  );
};

export default OrganismDisplayViewApiFixed;

// Styled Components
const StyledLocationTitle = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 18px;
  font-family: Pretendard;
  font-weight: 800;
  line-height: 1.1;
  text-align: center;
  letter-spacing: -0.8px;
  white-space: nowrap;
`;

const StyledTimeText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 28px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 1.1;
  text-align: center;
`;

const StyledDateText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 12px;
  font-family: Pretendard;
  font-weight: 500;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
  opacity: 0.7;
`;

const StyledTemperatureText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 32px;
  font-family: Poppins;
  font-weight: 600;
  line-height: 1;
`;

const StyledWeatherStatusText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
`;

const StyledMinMaxTempText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 12px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 1.1;
`;

const StyledFeelsLikeText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
`;

const StyledWeatherLabelText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 12px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 1.2;
`;

const StyledWeatherValueText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 16px;
  font-family: Poppins;
  font-weight: 500;
  line-height: 1;
`;

const StyledWeatherUnitText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 8px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.5px;
`;

const StyledMessageText = styled.span`
  color: ${({ themeMode }) => getApiThemeColor("textColor", themeMode)};
  font-size: 11px;
  font-family: Pretendard;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
  overflow: visible;
  text-align: center;

  ${({ isOverflowing }) =>
    isOverflowing
      ? css`
          display: inline-block;
          will-change: transform;
          animation: ${marqueeAnimation} 15s linear infinite;
          position: relative;

          &::after {
            content: attr(data-text);
            position: absolute;
            left: 100%;
            top: 0;
            padding-left: 4em; /* Gap between repeated text */
            white-space: nowrap;
          }
        `
      : css`
          overflow: visible;
        `}
`;

const StyledDivider = styled.div`
  width: 1px;
  height: 12px;
  background: ${({ themeMode }) => getApiThemeColor("dividerColor", themeMode)};
  opacity: 0.6;
  border-radius: 0.5px;
  align-self: center;
`;

// Icon Components
const StyledHumidityIcon = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  background-image: url(${humidityIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

const StyledWindSpeedIcon = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  background-image: url(${windspeedIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

const StyledRainIcon = styled.div`
  width: 16px;
  height: 16px;
  position: relative;
  background-image: url(${precipitationIcon});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  flex-shrink: 0;
`;

// Layout Components
const StyledMainContainer = styled.div`
  width: 192px;
  height: 448px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: ${({ themeMode }) =>
    getApiThemeColor("mainBackgroundColor", themeMode)};
  overflow: hidden;
  display: flex;
  box-sizing: border-box;
`;

const StyledContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  display: flex;
  box-sizing: border-box;
  gap: 8px;
  overflow: hidden;
  padding: 16px 8px;
`;

// 메인 콘텐츠 영역 (타이틀 + 날씨메인 + 상세)
const StyledMainContentArea = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  gap: 6px;
  overflow: visible;
  justify-content: flex-start;
`;

// 섹션 1: 타이틀 섹션 (고성군, 시간, 날짜)
const StyledTitleSection = styled.div`
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
  display: flex;
  overflow: visible;
  margin-top: 24px;
`;

const StyledDateTimeSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 6px;
  display: flex;
`;

// 섹션 2: 날씨 메인 섹션 (아이콘, 온도, 날씨상태, 최저/최고, 체감온도)
const StyledWeatherMainSection = styled.div`
  width: 100%;
  flex: 0 0 auto;
  height: 132px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
  overflow: hidden;
`;

const StyledWeatherIconSection = styled.div`
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
  width: 100%;
`;

const StyledTemperatureSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  display: flex;
`;

const StyledTempInfoSection = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  display: flex;
  width: 100%;
`;

const StyledMinMaxSection = styled.div`
  opacity: 0.8;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: flex;
`;

// 섹션 3: 날씨 상세 섹션 (습도, 풍속, 강수량)
const StyledWeatherDetailsSection = styled.div`
  width: 100%;
  flex: 0 0 auto;
  height: auto;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 6px;
  display: flex;
  overflow: visible;
  box-sizing: border-box;
  padding: 4px 4px 4px 4px;
`;

const StyledWeatherDetailCard = styled.div`
  padding: 8px 10px;
  background: ${({ themeMode }) =>
    getApiThemeColor("weatherCardBackground", themeMode)};
  border-radius: 4px;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex: 1;
  box-sizing: border-box;
`;

const StyledDetailIconSection = styled.div`
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  display: flex;
`;

const StyledDetailValueSection = styled.div`
  justify-content: flex-end;
  align-items: flex-end;
  gap: 2px;
  display: flex;
`;

const StyledWeatherIcon = styled.img`
  width: 52px;
  height: 52px;
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
`;

// 섹션 4: 하단 메시지 섹션
const StyledBottomMessage = styled.div`
  width: 168px;
  flex: 0 0 auto;
  height: 24px;
  margin: 14px 4px;
  padding: 8px;
  border-top: 1px
    ${({ themeMode }) => getApiThemeColor("bottomBorderColor", themeMode)} solid;
  border-bottom: 1px
    ${({ themeMode }) => getApiThemeColor("bottomBorderColor", themeMode)} solid;
  backdrop-filter: blur(2px);
  justify-content: center;
  align-items: center;
  display: flex;
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
`;
